import { useState } from 'react'

import { useTranslation } from 'react-i18next'

import { CompactAlert } from '~/components/common/CompactAlert'
import { now as serverNow } from '~/models/clock'
import { GuidanceActionButton } from '~/pages/ProcurementPlanDetail/components/SubmitGuidanceAlert'
import { resolveSpotTradeResultMismatchBody } from '~/pages/ProcurementPlanDetail/models/spotTradeResultMismatch'

type Props = {
  /** 計画の対象日 (カレンダー日)。本文 2 文目の「前日 17:00」 の基準。無ければ undefined。 */
  targetDate: Date | undefined
  /** 「計画を作り直す」 を押せない (閲覧のみ・計画の対象日が無い) 時 true。 */
  recreateDisabled: boolean
  onRecreate: () => void
}

/**
 * 提出後に届いたスポットの約定量が計画と違う時のバナー (AC-PPP-020 / 021。design
 * `submission-detail.html` の `#sd-spot-result`)。本文 2 文目は mount した時点の時刻で選び、
 * 時刻が進んでも選び直さない (spec「表示した時点で判定する」)。
 */
export const SpotTradeResultMismatchAlert = ({
  targetDate,
  recreateDisabled,
  onRecreate,
}: Props): React.ReactElement => {
  const { t } = useTranslation()
  const [body] = useState(() =>
    resolveSpotTradeResultMismatchBody(targetDate, serverNow()),
  )
  return (
    <CompactAlert
      description={
        body.key ===
        'page:planSubmission.spotTradeResultMismatch.bodySubmitFrom'
          ? t(body.key, { submitFrom: body.submitFrom })
          : t(body.key)
      }
      status="warning"
      title={t('page:planSubmission.spotTradeResultMismatch.title')}
    >
      <GuidanceActionButton
        action={{
          labelKey: 'page:procurementPlanDetail.submitGuidance.recreate',
          kind: 'recreate',
          disabled: recreateDisabled,
        }}
        onAction={onRecreate}
      />
    </CompactAlert>
  )
}
